<section class="safetyprogramrow">
    <div class="container">        
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Safety Program</h3>
                            </header>                           
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section> 

<section style="padding-bottom: 3px;">
    <div class="container" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-12">
                <h1 class="theme_color">
                    <strong>SFI Safety</strong> creates custom OSHA-compliant written safety programs for companies in Colorado, the Carolinas, Arizona, Florida, and nationwide.
                    <!-- <strong>Written safety programs</strong> are vital to the success of your company and your employees. -->
                </h1>

                <p class="theme_color fontSize">
                    A written safety program outlines the processes used to identify workplace hazards, prevent injuries and accidents, and respond effectively when incidents occur. It also helps communicate clear safety expectations and responsibilities to employees, supervisors, and subcontractors.
                </p>

                <p class="theme_color fontSize">
                    SFI Safety can work with you to develop a <strong><a href="/nsp" class="theme_color"><u>new safety program</u></a></strong>, or
                    <strong><a href="/rsp" class="theme_color"><u>review and revise</u></a></strong> your company’s existing program to strengthen its effectiveness, address current OSHA requirements, and better support your operations.
                </p>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="300" style="padding-top: 20px;">
                <img src="../../assets/images/safety program.png" class="img-fluid"  alt=""/><br/>                
            </div>
            <div class="col-lg-8"  data-aos="fade-left" data-aos-delay="300" style="padding-top: 20px;">
                <h1 class="theme_color">
                    <strong>New site start-up!</strong>.
                </h1>

                <p class="theme_color fontSize">Are you a new site that is literally starting from the ground up and
                    needs help but isn’t sure where to start? Well look no further.
                    <strong><a href="/contact" class="theme_color"><u>Contact us</u></a></strong> to get an account set up and we can customize for your site: </p>

                <ul class="theme_color fontSize">
                    <li data-aos="fade-up" data-aos-delay="50"><i class="fa fa-check-circle fontRed"></i>&nbsp;A Safety Program</li>
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-check-circle fontRed"></i>&nbsp;Safety orientation hard hat stickers</li>
                    <!-- <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-check-circle fontRed"></i>&nbsp;<a href="/sv" class="theme_color"><u>Safety orientation hard hat stickers</u></a></li> -->
                    <li data-aos="fade-up" data-aos-delay="150"><i class="fa fa-check-circle fontRed"></i>&nbsp;<a href="/sv" class="theme_color"><u>Site specific safety orientation videos</u></a></li>
                    <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-check-circle fontRed"></i>&nbsp;Scheduled trainings </li>
                    <li data-aos="fade-up" data-aos-delay="250"><i class="fa fa-check-circle fontRed"></i>&nbsp;Site inspections </li>
                </ul>               
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4"  data-aos="fade-right" data-aos-delay="300" style="padding-top: 20px;">                
                <img src="../../assets/images/Safety-01.jpg" class="img-fluid pt-5"  alt=""/>
            </div>
            <div class="col-lg-8"  data-aos="fade-left" data-aos-delay="300" style="padding-top: 20px;">                
                <p class="theme_color fontSize pt-4">
                    <strong>How will a safety program benefit me?</strong>
                </p>

                <ul class="theme_color fontSize">
                    <li data-aos="fade-up" data-aos-delay="50"><i class="fa fa-check-circle fontRed"></i>&nbsp;Detects and corrects safety hazards</li>
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-check-circle fontRed"></i>&nbsp;Prevents OSHA violations</li>
                    <li data-aos="fade-up" data-aos-delay="150"><i class="fa fa-check-circle fontRed"></i>&nbsp;Protects workers from injury and illness</li>
                    <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-check-circle fontRed"></i>&nbsp;Improve compliance with laws and regulations</li>
                    <li data-aos="fade-up" data-aos-delay="250"><i class="fa fa-check-circle fontRed"></i>&nbsp;Lower injury and illness expenses</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-check-circle fontRed"></i>&nbsp;Enhance social responsibility goals</li>
                    <li data-aos="fade-up" data-aos-delay="350"><i class="fa fa-check-circle fontRed"></i>&nbsp;Reduce absenteeism and turnover</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-check-circle fontRed"></i>&nbsp;Increase productivity</li>
                    <li data-aos="fade-up" data-aos-delay="450"><i class="fa fa-check-circle fontRed"></i>&nbsp;Educate and empower workers</li>
                    <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-check-circle fontRed"></i>&nbsp;Improve the quality of the job being performed</li>
                    <li data-aos="fade-up" data-aos-delay="550"><i class="fa fa-check-circle fontRed"></i>&nbsp;Reduce worker compensation premiums</li>
                    <li data-aos="fade-up" data-aos-delay="600"><i class="fa fa-check-circle fontRed"></i>&nbsp;Enhance overall business operations</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section style="background-color: #f8f9fb;padding-bottom: 0%;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8"  data-aos="fade-right" data-aos-delay="300">
                <h1 class="theme_color">
                    <strong>Safety programs built to meet OSHA requirements—and support more than compliance.</strong>.
                </h1>

                <p class="theme_color fontSize">
                    SFI Safety follows OSHA-recommended practices when developing or revising written safety programs. 
                    Programs are available in English and Spanish and are designed to clearly communicate company safety expectations, employee responsibilities, and training requirements.
                </p>
                <p class="theme_color fontSize">
                    A strong written safety program should do more than satisfy a regulatory requirement. It should give employers, managers, supervisors, and workers practical guidance for recognizing hazards,
                     preventing injuries, and maintaining safe work practices every day.
                </p>
                <p class="theme_color fontSize">
                    Our Beyond Compliance approach helps clients build structured policies, procedures,
                     and expectations that support accountability, consistency, and continuous improvement.
                     Learn more about our <strong><a target="_parent" href="/oshaprocedures" class="theme_color"><u>OSHA Recommended Practices</u></a></strong>.
                </p>

                <p class="theme_color fontSize">
                    <a href="/contact"><strong><u>Contact us</u></strong></a> today to learn more or order yours at 303-649-1304 or customerservice@sfisafety.com
                </p>

            </div>
            <div class="col-lg-4 order-first order-md-last"  data-aos="fade-left" data-aos-delay="300">
                <img  src="../../assets/images/Safety-02.jpg" class="img-fluid"  alt=""/>
            </div>

        </div>
    </div>
</section>